import { useTranslation } from "react-i18next"
import { graphql, useFragment } from "react-relay"
import { CheckCircle } from "@phosphor-icons/react"
import { WithTooltip } from "@/hoc/with-tooltip"
import { appointmentDrawerCardHeaderReviewStatus_appointment$key } from "@/modules/common/waiting-room/appointment/__generated__/appointmentDrawerCardHeaderReviewStatus_appointment.graphql"

const AppointmentDrawerCardHeaderReviewStatusFragment = graphql`
  fragment appointmentDrawerCardHeaderReviewStatus_appointment on Appointment {
    reviewStatus
  }
`

type AppointmentDrawerCardHeaderProps = {
  appointmentRef: appointmentDrawerCardHeaderReviewStatus_appointment$key
}

const AppointmentDrawerCardHeaderReviewStatus = ({ appointmentRef }: AppointmentDrawerCardHeaderProps) => {
  const { t } = useTranslation()

  const { reviewStatus } = useFragment<appointmentDrawerCardHeaderReviewStatus_appointment$key>(
    AppointmentDrawerCardHeaderReviewStatusFragment,
    appointmentRef,
  )

  return (
    reviewStatus === "REVIEWED" && (
      <WithTooltip text={t("scheduling.waitingRoom.reviewedTooltip")}>
        <CheckCircle className="text-success h-6 w-10" data-testid="reviewed-appointment-icon" />
      </WithTooltip>
    )
  )
}

export { AppointmentDrawerCardHeaderReviewStatus }
